<template>
	<div class="control">
		<div class="control-item" v-bind:class="{ collapsible: checkbox.collapsible, 'has-children': (checkbox.subgroup != undefined && checkbox.subgroup.length > 0) }" v-for="(checkbox, index) in checkboxes">
			<div class="form-group custom-checkbox">
				<input tabindex="0" type="radio" v-bind:id="checkbox.value+'-filter'" v-bind:value="checkbox.value" v-model="selectedValues" v-on:change="updateFilters(checkbox, $event)" v-bind="dataAttr(checkbox)" />
				<label tabindex="-1" v-bind:for="checkbox.value+'-filter'">{{ checkbox.label }}</label>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['controls', 'parent', 'specification'],
		data: function () {
			return {
				checkboxes: this.controls,
				selectedValues: "English",				
			}
		},
		watch: {
			parent: {
				handler(newVal) {
				},
				deep: true,
			}
		},
		beforeCreate: function () {
			this.$options.components.LanguageControl = require('./language-control.vue').default;
		},
        mounted: function () {
            let initialData = this.$store.state.listing.specification[this.specification];

            if (initialData !== null && initialData !== '') {
                this.selectedValues = initialData[0];
            }
            else {
                this.selectedValues = "English";
            }

			// clear current input on reset
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/resetSpecification') {
					this.selectedValues = "";
				}
            });
        },
        updated: function () {
            if (this.selectedValues.length === 0) {
                this.selectedValues = "English";
            }
        },
		methods: {
			updateFilters(checkbox, $event) {
				const value = $event.target.value;
				const checked = $event.target.checked;

				if (value === 'English') {
					if (!checked) {
						// Prevent unchecking 'English' if it's the only selected value
						if (this.selectedValues.length === 1 && this.selectedValues.includes('English')) {
							$event.preventDefault();
							return;
						}
					}
					// Don't change other selections, just allow selecting/deselecting English
				} else {
					if (checked) {
						// Add the new value; don't remove 'English'
						if (!this.selectedValues.includes(value)) {
							this.selectedValues = value;
						}
					} else {
						// Remove the unchecked value
						//const index = this.selectedValues.indexOf(value);
						//if (index > -1) {
						//	this.selectedValues.splice(index, 1);
						//}
						// If nothing is selected, default back to 'English'
						if (this.selectedValues.length === 0) {
							this.selectedValues = 'English';
						}
					}
				}

				this.$emit('updatecheckboxfilter');
			},
			updateCheckboxFilter() {
				this.$emit('updatecheckboxfilter');
            },
            dataAttr(checkbox) {
				return {};
            },
			handleDefaultCheck(value) {
				if (value === 'English') {
				console.log(value);

					return true;
				}
			}
        }
	}
</script>